import type { SecuritySchemaCommandFactory } from 'components/SecuritySchema/model/SecuritySchemaModel';

interface ChangeRuleChainPageCommand {
  page: number;
}

export const changeRuleChainPage: SecuritySchemaCommandFactory<
  ChangeRuleChainPageCommand
> = (cmdContext) => {
  return (command) => {
    cmdContext.updateState((draft) => {
      draft.page = command.page;
    });
  };
};
